// extracted by css-extract-rspack-plugin
export default {"controlsContainer":"controls-container--uwyjMRNZo88bTX7V","controlsText":"controls-text--BrWOwAgwwtMq7pVs"};